import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';

import { router } from './router';
import { queryClient } from './lib/queryClient';
import { initTheme } from './lib/theme';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/Confirm';
import { AuthProvider } from './auth/AuthContext';
import { AuthGate } from './auth/gates';

// CSS global (tokens de diseño, tema claro/oscuro, componentes).
import './styles/index.css';

// Aplica el tema guardado antes del primer render (evita parpadeo).
initTheme();

// Auth propia sobre @insforge/sdk (el paquete @insforge/react está deprecado).
// AuthGate protege la app: sin sesión muestra el login.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <AuthProvider>
            <AuthGate>
              <RouterProvider router={router} />
            </AuthGate>
          </AuthProvider>
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
